export default __webpack_public_path__ + "static/ISO27701-99c17226c25b9d67afaf2b452e0392e6.png";